// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loaderContent":"Loader_loaderContent__oQ1Kc","load8":"Loader_load8__5xhlQ"};